exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".options-sty[data-v-1487e120]{color:#290202}.pageation[data-v-1487e120]{padding:30px 10px 20px;border-top:0}.resend-callback[data-v-1487e120]{cursor:pointer}.dialog-footer[data-v-1487e120]{padding-bottom:20px}.dialog-footer .btn[data-v-1487e120]{width:30%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1487e120","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/ent-access/signCallback.vue
// module id = xojI
// module chunks = 48